import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";

const TopSpeakers = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const [speakers, setSpeakers] = useState([]);
    const isArabic = i18n.language === "ar";


  const fetchTopSpeakers = async () => {
    try {
      const response = await axiosInstance.get(
        "/api/v1/users/speakers/home?type=4"
      );

      const items = response.data?.items ?? [];

      console.log("API Response Data:", items);

      setSpeakers(items.slice(0, 4));
    } catch (error) {
      console.error("Error fetching top speakers:", error);
    }
  };

  useEffect(() => {
    fetchTopSpeakers();
  }, []);

  return (
    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row justify-content-center mb-5">
          <div className="col-md-8 text-center">
            <h2 className="fw-bold text-primary-custom mb-3">
              {t("topRequestedSpeakers")}
            </h2>
            <p className="text-muted">{t("topRequestedSpeakersSubtitle")}</p>
          </div>
        </div>

        <div className="top-speakers-grid">
          {speakers.map((speaker, index) => (
            <div key={index} className="top-speaker-card">
              <img
                src={speaker.profileImage}
                className="top-speaker-image"
                alt={speaker.englishFullName || speaker.arabicFullName}
              />
              <h5 className="fw-bold mb-1">
                {language === "ar"
                  ? speaker.arabicFullName
                  : speaker.englishFullName}
              </h5>
              {/* <p className="text-muted small mb-2">
                {language === "ar"
                  ? speaker.arabicJobTitle
                  : speaker.englishJobTitle || t("noJobTitle")}
              </p> */}
              <div className="mt-2">
                {speaker.speakerSpecialies?.map((speciality, index) => (
                  <p className="text-muted small mb-2">
                    {isArabic
                      ? speciality.speciality.arabicName
                      : speciality.speciality.englishName}
                  </p>
                ))}
              </div>
              <div className="d-flex gap-2 mb-3">
                <span className="badge bg-primary-custom">
                  {speaker.speakerContributionCount || 0}+ {t("contributions_management")}
                </span>
              </div>
              <a
                href={`/speaker-detail/${speaker.id}`}
                className="btn btn-sm btn-outline-primary rounded-pill px-3"
              >
                {t("profile")}
              </a>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <a href="/speakers" className="btn btn-outline-primary px-4 py-2">
            {t("viewAllSpeakers")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default TopSpeakers;
